jQuery( document ).ready( function ( $ ) {
  $( '.add-mattress' ).on( 'click', function ( evt ) {
    evt.preventDefault();

    var $newMattress = $( '.mattress' ).last().clone( true ),
        oldId = $newMattress.data( 'id' ),
        newId = parseInt( oldId ) + 1;
    $newMattress.data( 'id', newId ).attr( 'data-id', newId );
    $newMattress.find( 'input[type="text"], select, textarea' ).each( function () {
      var $label = $( this ).prev( 'label' );
      $( this ).attr( 'id', $( this ).attr( 'id' ).replace( '-' + oldId, '-' + newId ) );
      $( this ).attr( 'name', $( this ).attr( 'name' ).replace( '-' + oldId, '-' + newId ) );
      $label.attr( 'for', $( this ).attr( 'id' ) );

      if ( $( this ).is( 'select' ) ) {
        $( this ).find( 'option' ).prop( 'selected', false );
      } else if ( $( this ).is( 'input[type="text"]' ) ) {
        $( this ).val( '' );
      } else if ( $( this ).is( 'textarea' ) ) {
        $( this ).val( '' );
      }
    });
    
    $newMattress.appendTo( '.mattresses' );
    
  });

  $( '.remove-mattress' ).on( 'click', function ( evt ) {
    evt.preventDefault();

    if ( $( '.mattresses .mattress' ).length > 1 ) {
      $( this ).parent( '.mattress' ).remove();
    }
  });
});